import { LinkProps } from './LinkScreen';
import * as React from 'react';
import { ScreenLinkAction } from '../../model/Action';
import Screens from '../../model/Screens';
import { MachineContext } from '../fsm/useMachine';
import { throwIfWrong } from '../../model/Assets';
import { SlideFadeIcon, SlideFlowIcon, SlideTransitionIcon } from '../icons/TransitionIcons';
import { Slash } from 'react-feather';


export const FlowScreen: React.FC<LinkProps<ScreenLinkAction>> = ({ set_action, existing }) => {
    const [current,] = React.useContext(MachineContext)
    const [screenId, setscreenID] = React.useState(existing?.screenID || current.context.flow.screens[0].id)
    const [transition, setTransition] = React.useState(existing?.ScreenLinkTransition || "4")

    const asAction = (tition: string) => {
        const use = tition
        const action = new ScreenLinkAction(use, screenId)
        set_action({ __tag: "screen", value: action })
    }

    React.useEffect(() => {
        if (existing != undefined) {
            existing.screenID && setscreenID(existing.screenID)
            setTransition(existing.ScreenLinkTransition)
        }
    }, [])

    const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
        setTransition(e.currentTarget.dataset.index!)
        asAction(e.currentTarget.dataset.index!)
    }

    return (
        <React.Fragment>
            <div className="linkMenu-desc">
                <h3>Set Screen Link</h3>
                <p>Select Target Screen</p>
            </div>
            <div className="screen_scroll"
            >
                {current.context.flow.screens.map((screen: Screens) => {
                    const isActive = screen.id == screenId
                    let preview = screen.previewScreenShot.externalURL
                    if (preview.__tag === "file") {
                        throwIfWrong("string", preview)
                    } else {
                        let imgSrc = preview.value
                        return (
                            <div className="padding_10"
                                key={screen.id}
                            >
                                <img
                                    src={imgSrc}
                                    height="120px"
                                    className={`screen_item ${isActive ? "selected screen_shot" : "screen_shot"}`}
                                    onClick={() => {
                                        setscreenID(screen.id)
                                        asAction(transition)
                                    }}
                                />
                            </div>
                        )
                    }
                })}
            </div>
            <div className="transition_item_wrapper">
                <div
                    data-index="1"
                    onClick={onClick}
                    className={`transitionItem ${transition == "1" ? "active" : ""}`}
                >
                    <SlideTransitionIcon />
                    <span>Slide In</span>
                </div>
                <div
                    data-index="2"
                    onClick={onClick}
                    className={`transitionItem ${transition == "2" ? "active" : ""}`}
                >
                    <SlideFadeIcon />
                    <span>Fade In</span>
                </div>
                <div
                    data-index="3"
                    onClick={onClick}
                    className={`transitionItem ${transition == "3" ? "active" : ""}`}
                >
                    <SlideFlowIcon />
                    <span>Flow to Screen</span>
                </div>
                <div
                    data-index="4"
                    onClick={onClick}
                    className={`transitionItem ${transition == "4" ? "active" : ""}`}
                >
                   <Slash className="feather" />
                    <span>None</span>
                </div>
            </div>
        </React.Fragment>
    )
}
